import React from 'react';
import { HorizontalGroup, Textarea, Input, Tooltip, VerticalGroup, Column, Divider } from '@libs/uikit/Components';
import { TextWithPreview } from './TextWithPreview';
import styled from 'styled-components';

const Div = styled.div`
    position: relative;
    height: 30px;
`;

const ConfiguratedInput = ({ name, ak, text, changeAk, hasError }) => (
    <HorizontalGroup style={{ marginTop: 0, marginBottom: 0 }}>
        <VerticalGroup>
            <TextWithPreview style={{ fontStyle: 'italic' }}>{text}</TextWithPreview>
            <Div>
                {hasError && <Tooltip text={'ak must contain the 0...9 or a...z characters'} error position="right" />}
                <Input
                    name={name}
                    value={ak}
                    onChange={({ target: { value, name } }) => changeAk(name, value)}
                    error={hasError}
                    maxLength="10"
                />
            </Div>
            {hasError && <TextWithPreview>{hasError}</TextWithPreview>}
        </VerticalGroup>
    </HorizontalGroup>
);

export const Field = (props) => {
    const onChange = ['htmlRichMedia', 'safeInFeedLandscape'].includes(props.name)
        ? props.checkSelectedField
        : props.onChange;

    return (
        <>
            <HorizontalGroup style={{ marginTop: 4, marginBottom: 4 }}>
                <Column>
                    <input
                        style={{ marginRight: '12px' }}
                        type="checkbox"
                        onChange={onChange}
                        checked={props.selected}
                    />
                    <TextWithPreview
                        onClick={onChange}
                        required={props.selected}
                        onMouseEnter={() => props.onOver(props.preview)}
                        onMouseLeave={() => props.onOver(null)}
                    >
                        {props.text}
                    </TextWithPreview>
                </Column>
            </HorizontalGroup>
            {props.selected && (
                <>
                    <ConfiguratedInput
                        name={props.name}
                        ak={props.ak}
                        text={props.alternate || props.text}
                        changeAk={props.changeAk}
                        hasError={props.hasError}
                    />
                    {(typeof props.autoClose !== 'undefined' || typeof props.vcr !== 'undefined') && (
                        <HorizontalGroup>
                            {typeof props.autoClose !== 'undefined' && (
                                <>
                                    <input
                                        key="autoclose"
                                        type="checkbox"
                                        checked={props.autoClose}
                                        onChange={() => props.toggleAutoClose(props.name)}
                                    />
                                    <TextWithPreview onClick={() => props.toggleAutoClose(props.name)}>
                                        Close ad spot after video completed
                                    </TextWithPreview>
                                </>
                            )}
                            {typeof props.vcr !== 'undefined' && (
                                <>
                                    <input
                                        key="vcr"
                                        type="checkbox"
                                        checked={props.vcr}
                                        onChange={() => props.toggleVcr(props.name)}
                                    />
                                    <TextWithPreview onClick={() => props.toggleVcr(props.name)}>
                                        Video on top of content when ad spot out of view
                                    </TextWithPreview>
                                </>
                            )}
                        </HorizontalGroup>
                    )}
                    <Divider />
                </>
            )}
        </>
    );
};

export const FieldPassback = (props) => (
    <>
        <HorizontalGroup>
            <input type="checkbox" onChange={props.onChange} checked={props.selected} />
            <TextWithPreview
                onClick={props.onChange}
                onMouseEnter={() => props.onOver(props.preview)}
                onMouseLeave={() => props.onOver(null)}
            >
                {props.text}
            </TextWithPreview>
        </HorizontalGroup>
        {props.selected && (
            <>
                <HorizontalGroup>
                    <Textarea
                        width="300px"
                        name={props.name}
                        value={props.ak}
                        onChange={({ target: { value, name } }) => props.changeAk(name, value)}
                    />
                    <TextWithPreview>{props.alternate}</TextWithPreview>
                </HorizontalGroup>
                <HorizontalGroup>
                    <HorizontalGroup>
                        <Input
                            width="50px"
                            value={props.width}
                            onChange={({ target: { value } }) => props.changePassbackSize('width')(value)}
                        />
                        <TextWithPreview>Width</TextWithPreview>
                        <Input
                            width="50px"
                            value={props.height}
                            onChange={({ target: { value } }) => props.changePassbackSize('height')(value)}
                        />
                        <TextWithPreview>Height</TextWithPreview>
                    </HorizontalGroup>
                </HorizontalGroup>
            </>
        )}
    </>
);
